
import TableList from "@components/templates/tablelist";
import { HttpSaAccountList } from '@/service/boss/allot';
import { mapState,mapGetters } from "vuex";
import comExcel from '@components/templates/excelalert'
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
        }
    },
    methods: {
        ajaxRequest: HttpSaAccountList,
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockAccountAssign/warehouse/export", this.formData, 'download').catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                break

            }
        },
    },
    computed: {
        ...mapGetters('diction',['getNewDifferentAllProductList','getNewAccountList','getNewWarehouseIdList']),
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewDifferentAllProductList,
                    props:{
                        filterable:true,
                    },
                    show:true,
                },

                {
                    label: this.$t('global.common.channel',{defaultValue:'店铺'}),
                    tag: 'vSelect',
                    key: 'EQ_accountFlag',
                    show:true,
                    options: this.getNewAccountList,
                    props:{
                        filterable:true,
                    }
                },

                {
                    label: "SellerSKU",
                    tag: 'vInput',
                    key: 'EQ_sellerSku',
                    show:true,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    show:true,
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    options:this.getNewWarehouseIdList,
                    props:{
                        filterable:true,
                    },
                    show:true,
                },
            ]
        },
        ToolsData(){
            return [
                {
                    name: "查询条件导出",
                    theme: 'info',
                    operate: 'exportQuery',
                },
            ]
        },
        // table的展示数据
        columns() {
            return  [
            {
                title: this.$t('global.common.project',{defaultValue:'项目'}),
                render: (h, { row }) => this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)
            },
            {
                title: this.$t('erp.managewarehouse.shop_type',{defaultValue:'店铺类型'}),
                key:'accountType',
            },
            {
                title: this.$t('global.common.channel',{defaultValue:'店铺'}),
                key:'accountFlag',
            },
            {
                title: 'SellerSKU',
                key:'sellerSku',
                sortable: true
            },
            {
                title: 'ERPSKU',
                key:'erpSku',
                sortable: true
            },
            {
                title: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                render: (h, { row }) => this.findRenderLabel(this.getNewWarehouseIdList, row.orgWarehouseId)
            },
            {
                title: '店铺仓库',
                key:'channelWarehouseCode',
                sortable: true
            },
            {
                title:  this.$t('erp.virtualstore.computationnumber',{defaultValue:'计算数量'}),
                key: 'quantity',
                sortable: true
            },
            {
                title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                key: 'updatedAt',
                sortable: true
            },
            {
                title: this.$t('erp.channel.is_push',{defaultValue:'是否推送'}),
                sortable: true,
                render: (h,{ row }) => {
                    const aa = row.isPush == true ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
                    return <span>{aa}</span>
                }
            },
        ];
        },

    },

};
